import { legacy_createStore } from "redux";
import MenuService from "../services/menu.service";
import authStore from "../_stores/auth.store";
import { actions as AppActions } from "../_stores/app.store";

const types = {
  SET_SIDENAV_ITEMS: "SET_SIDENAV_ITEMS",
};

const initialState = {
  sideNavItems: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SIDENAV_ITEMS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const store = legacy_createStore(
  reducer,
  /* preloadedState, */ window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const setSideNav = async (dispatch, payload = {}) => {
  let menuList = [];
  try {
    AppActions.setLoading(true);
    const resp = await MenuService.getAll();
    if (resp.data.success) {
      menuList = resp.data.data && resp.data.data.length ? resp.data.data : [];
    }
    AppActions.setLoading(false);
  } catch (err) {
    console.error("Side Menu error catch => ", err);
  }
  payload.sideNavItems = menuList;
  dispatch({ type: types.SET_SIDENAV_ITEMS, payload });
};

const actions = {
  setSideNav,
};

if (authStore.getState().auth_reducer.authToken) actions.setSideNav(store.dispatch, {});

export { store as default };
export { types, actions };
